import { AlertCircleSolidIcon } from '@bfe/moly-icons';
import styles from './style.module.scss';
import { useFm, useWallet } from '@web3/base-hooks';
import { BybitWalletEx, WalletTypeTextKey } from '@/config/common';
import { useMemo } from 'react';
import { WalletType } from '@web3/base-utils';
import { SwitchWalletButton } from '../SwitchWalletButton';

type IWalletTypeTip = {
  walletTypeList: WalletType[];
};

export function WalletTypeTip(props: IWalletTypeTip) {
  const { walletTypeList } = props;
  const { isLogin, evmWalletInfo, walletType } = useWallet();

  const fm = useFm();

  const walletListText = useMemo(() => {
    const textArr: any[] = [];
    walletTypeList.forEach((item) => {
      item !== WalletType.PRIVATE_KEY &&
        textArr.push(fm(WalletTypeTextKey[item]));
    });
    return textArr.join(',');
  }, [walletTypeList]);

  // 支持全部钱包
  const supportAll = useMemo(() => {
    let flag = true;
    [WalletType.CLOUD, ...BybitWalletEx].forEach((item) => {
      if (!walletTypeList.includes(item)) {
        flag = false;
      }
    });
    return flag;
  }, [walletTypeList]);

  if (supportAll) {
    return null;
  }

  return !isLogin || !walletTypeList.includes(walletType) ? (
    <div className={`${styles['wallet-type-tip']} main mt-8 text-sm`}>
      <AlertCircleSolidIcon className="text-main" />
      <span>
        {fm('walletTypeSwitchTip', {
          walletType: walletListText,
        })}
      </span>
      <SwitchWalletButton type="textlink" walletTypeList={walletTypeList} />
    </div>
  ) : null;
}
